module.exports = __webpack_public_path__ + "img/sl.d86d8b1f.svg";